/**
 * @Author: 左建
 * @Date: 2022/7/14 13:53
 * @LastEditTime: 2022/7/14 13:53
 * @Description: 问卷发布弹窗一些静态化数据
*/
// 参与方式单选按钮的options
export const joinModeOptions = Object.freeze([
    {
        label: "面向公众参与",
        value: 0
    },
    {
        label: "机构所有人员参与",
        value: 1
    },
    {
        label: "机构指定人员参加",
        value: 2
    }
])
